import React, { Component } from 'react';

class Footer extends Component {
  render() {

    if(this.props.data){
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
      <footer>
        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">{networks}</ul>
            <ul>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2625.1129925274595!2d2.7703068158566455!3d48.85605570882486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e61cd7ee5d4bd5%3A0x172a662c0e83afb0!2s3%20Rue%20de%20la%20Font%20Rouge%2C%2077700%20Chessy!5e0!3m2!1sfr!2sfr!4v1664532208810!5m2!1sfr!2sfr"
                width="600"
                height="450"
                
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </ul>

            <ul className="copyright">
              <li>&copy; Copyright 2020</li>
              <li>
                Illustrations par{" "}
                <a href="mailto:yinji.lesprit@gmail.com">Yinji LESPRIT</a>
              </li>
              <li>
                <a href="/cgv.html">Conditions Générales de Vente </a>
              </li>
            </ul>
          </div>
          <div id="go-top">
            <a className="smoothscroll" title="Back to Top" href="#home">
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
